// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2rSoN","card_img_top":"Card_card_img_top__10TAO","card_body":"Card_card_body__1uLgn","card_title":"Card_card_title__3NAF_","green":"Card_green__1bXQ0"};